import { c as scrollTo, s as scrollLock, e as escListener } from "./utilities-utils.js";
import "./utilities-nav-utils.js";
function setSliderOnClick(sliderEl) {
  if (!sliderEl) return;
  sliderEl.swiper.on("click", function() {
    const slides = this.virtual.slides.length > 0 ? this.virtual.slides : this.slides;
    if (slides[this.clickedIndex].getAttribute("data-id")) {
      if (!slides[this.clickedIndex].classList.contains("model") && !slides[this.clickedIndex].classList.contains("video")) {
        openLightBox(slides[this.clickedIndex].getAttribute("data-id"));
      }
    }
  });
}
function setGridOnClick(galleryEl) {
  if (!galleryEl) return;
  galleryEl.querySelectorAll("figure:not(.figure--model)").forEach((figure) => {
    figure.addEventListener("click", () => {
      openLightBox(figure.parentNode.getAttribute("data-id"));
    });
  });
}
function setGalleryMediaOnClick() {
  const productGallery = document.querySelector(".zoom-lightbox");
  if (productGallery && !productGallery.swiper || productGallery.swiper.destroyed == true) {
    setGridOnClick(productGallery);
  } else {
    setSliderOnClick(productGallery);
  }
}
window.addEventListener("load", setGalleryMediaOnClick);
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    setTimeout(setGalleryMediaOnClick, 100);
  });
}
let lightboxEl, videos = [];
const closeLightBox = () => {
  scrollLock(false);
  escListener(false);
  if (lightboxEl) {
    lightboxEl.classList.remove("pdp-lightbox--open");
  }
  if (videos && videos.length) {
    Array.from(videos).forEach(function(video) {
      if (video.tagName.toLowerCase() === "video") {
        video.pause();
      } else {
        var src = video.src;
        video.src = src;
      }
    });
  }
};
const jumpToTargetFigure = (id) => {
  lightboxEl.scrollTop = lightboxEl.querySelector('figure[data-id="' + id + '"').offsetTop + parseInt(getComputedStyle(lightboxEl).paddingTop);
};
const openLightBox = (id) => {
  lightboxEl = document.querySelector(".pdp-lightbox");
  if (lightboxEl) {
    const closeButton = lightboxEl.querySelector(".pdp-lightbox__close");
    videos = lightboxEl.querySelectorAll("iframe, video");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        closeLightBox();
      });
    }
    lightboxEl.querySelectorAll(".figure--image").forEach((image) => {
      image.addEventListener("click", closeLightBox);
    });
  }
  scrollLock(true);
  escListener(true, closeLightBox);
  lightboxEl.classList.add("pdp-lightbox--open");
  jumpToTargetFigure(id);
  const closeBtn = lightboxEl.querySelector(".pdp-lightbox__close");
  if (closeBtn) {
    closeBtn.removeAttribute("disabled");
  }
};
function enableStickyBar() {
  const scrollATC = document.querySelectorAll(".scroll-atc");
  const stickyBars = document.querySelectorAll(".sticky-add-to-cart");
  if (stickyBars.length === 2) {
    stickyBars[1].remove();
  }
  const stickyBar = stickyBars[0];
  if (stickyBar) {
    document.body.prepend(stickyBar);
  }
  const innerContainer = document.querySelector(".sticky-add-to-cart__inner");
  const stickyBorderElement = document.querySelector(
    ".main-product__add-to-cart .button--add-to-cart"
  );
  if (stickyBorderElement && stickyBar) {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove("active");
          innerContainer.classList.remove("sticky-priority");
          return;
        }
        if (entry.boundingClientRect.top > 0) {
          stickyBar.classList.remove("active", "sticky-subheader");
          innerContainer.classList.remove("sticky-priority");
        } else {
          stickyBar.classList.add("active", "sticky-subheader");
          innerContainer.classList.add("sticky-priority");
        }
      },
      {
        root: null,
        threshold: 1
      }
    );
    observer.observe(stickyBorderElement);
  }
  if (scrollATC) {
    scrollATC.forEach((button) => {
      button.addEventListener("click", function(e) {
        const elem = document.querySelector(".main-product__add-to-cart");
        const variantSelects = document.querySelector(".main-product__variant-selector");
        const scrollToElement = variantSelects || elem;
        scrollTo(scrollToElement);
        setTimeout(function() {
          variantSelects.classList.add("ux-shake");
          setTimeout(function() {
            variantSelects.classList.remove("ux-shake");
          }, 800);
        }, 800);
      });
    });
  }
}
window.addEventListener("load", enableStickyBar);
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", enableStickyBar);
}
function enableSimpleStickyATC() {
  const stickyBtn = document.querySelector(".button--sticky-add-to-cart");
  const mainATC = document.querySelector(".button--add-to-cart");
  if (!stickyBtn || !mainATC) return;
  stickyBtn.classList.remove("is-sticky-visible");
  const observer = new window.IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBtn.classList.remove("is-sticky-visible");
      } else {
        stickyBtn.classList.add("is-sticky-visible");
      }
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "-50% 0px 0px 0px"
      // Trigger when mainATC crosses the vertical center of the viewport
    }
  );
  observer.observe(mainATC);
}
window.addEventListener("load", enableSimpleStickyATC);
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", enableSimpleStickyATC);
}
